var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.5H20C21.105 5.5 22 6.395 22 7.5V18.5C22 19.605 21.105 20.5 20 20.5H4C2.895 20.5 2 19.605 2 18.5V16M20 14H14V15C14 15.276 13.776 15.5 13.5 15.5H10.5C10.224 15.5 10 15.276 10 15V14H3C2.45 14 2 13.55 2 13V7.5C2 6.3955 2.8955 5.5 4 5.5H9V4C9 3.45 9.45 3 10 3H14C14.55 3 15 3.45 15 4V5.5",
    stroke: "#061F40",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/organizations.abe22f20e61375858515a78d56400c34.svg";
export { ForwardRef as ReactComponent };